/**
 * Scroll-Reveals und Mengenzähler.
 *
 * Die Klasse `js` am <html> schaltet die Reveal-Animation erst frei. Ohne
 * JavaScript bleibt jeder Inhalt sichtbar — kein Text hängt an einem Skript.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals ---------- */
  var targets = document.querySelectorAll('.reveal');

  if (targets.length && 'IntersectionObserver' in window && !reduceMotion) {
    document.documentElement.classList.add('js');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---------- Mengenzähler ----------
     Delegiert, damit auch nachgeladene Karten funktionieren. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-step]');
    if (!button) return;

    var wrap = button.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;

    event.preventDefault();

    var step = parseInt(button.dataset.qtyStep, 10);
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || Infinity;
    var next = (parseInt(input.value, 10) || min) + step;

    input.value = Math.min(max, Math.max(min, next));
    input.dispatchEvent(new Event('change', { bubbles: true }));

    wrap.querySelectorAll('[data-qty-step]').forEach(function (b) {
      var s = parseInt(b.dataset.qtyStep, 10);
      b.disabled = s < 0 ? input.value <= min : input.value >= max;
    });
  });

  /* ---------- Flaschengröße in der Karte ----------
     Die Radio-Felder heißen `id`, der Kaufbutton nimmt die gewählte Variante
     also von selbst mit. Hier wird nur die Preisanzeige nachgezogen — ohne
     JavaScript stimmt der Warenkorb trotzdem, nur der Preis daneben zeigt
     dann die Voreinstellung. */
  document.addEventListener('change', function (event) {
    var radio = event.target.closest('[data-variant-picker] input[type="radio"]');
    if (!radio) return;

    var karte = radio.closest('.card-product');
    if (!karte) return;

    var setze = function (selektor, text) {
      var el = karte.querySelector(selektor);
      if (!el) return;
      el.textContent = text || '';
      el.hidden = !text;
    };

    setze('[data-price]', radio.dataset.preis);
    setze('[data-compare-price]', radio.dataset.streich);
    setze('[data-unit-price]', radio.dataset.grund);
  });
})();
